export default __webpack_public_path__ + "static/eeshawar-a28f76418b99c3904826f8d94d3b317c.png";